import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useReactToPrint } from "react-to-print";

const headerStyle = {
  p: 1,
  textAlign: "center",
  bgcolor: "#4527a0",
  color: "#FFF",
};
const cellStyle = {
  p: 0,
  textAlign: "center",
  border: "1px solid black",
};
function SalesReturnReportPrint() {
  const { companyInfo } = useSelector((state) => state?.common);
  const logo = JSON.parse(companyInfo?.logo);
  const location = useLocation();
  const {
    tabledata,
    fromDate,
    toDate,
    selectedcustomer,
    godown,
    salesType,
    totals,
  } = location.state || {};
  const navigate = useNavigate();
  const componentRef = useRef();

  const columns = [
    { headerName: "Date" },
    { headerName: "Ret No" },
    { headerName: "Customer Name" },
    { headerName: "Sales Type" },
    { headerName: "Sub-Total" },
    { headerName: "Disc" },
    { headerName: "Tax" },
    { headerName: "Total Amt" },
  ];

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint: () => {
      navigate(-2);
    },
  });
  useEffect(() => {
    handlePrint();
  }, [handlePrint]);

  const sumOfSubTotal =
    totals?.subTotal ||
    tabledata?.reduce(
      (acc, curr) => acc + (parseFloat(curr.BillNetTotalField) || 0),
      0
    );
  const sumOfDisc =
    totals?.disc ||
    tabledata?.reduce(
      (acc, curr) => acc + (parseFloat(curr.BillDiscAmtField) || 0),
      0
    );
  const sumOfTax =
    totals?.tax ||
    tabledata?.reduce(
      (acc, curr) =>
        acc + (parseFloat(curr.TaxAmt) || parseFloat(curr.Tax) || 0),
      0
    );
  const sumOfTotalAmt =
    totals?.totalAmt ||
    tabledata?.reduce(
      (acc, curr) => acc + (parseFloat(curr.BillTotalField) || 0),
      0
    );

  return (
    <div ref={componentRef}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Box px={2}>
          <Box
            component={"img"}
            sx={{ height: "auto", width: 120 }}
            src={logo?.img}
          />
        </Box>
        <Box>
          <Typography variant="h2" fontWeight={"bold"}>
            Sales Return Report
          </Typography>
          <Box>Date {`${fromDate} - ${toDate}`}</Box>

          {selectedcustomer && selectedcustomer !== "ALL" && (
            <Box>Customer: {selectedcustomer}</Box>
          )}

          {godown && godown !== "ALL" && <Box>Outlet: {godown}</Box>}

          {salesType && salesType !== "ALL" && (
            <Box>Sales Type: {salesType}</Box>
          )}
        </Box>
        <Box px={2}>
          <Stack>
            <Typography textAlign={"center"} variant="h3">
              {companyInfo?.Name}
            </Typography>
            <Typography
              textAlign={"center"}
              variant="h5"
            >{`${companyInfo?.Add1} ${companyInfo?.Add2}`}</Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.Ph}
            </Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.city_name} {companyInfo?.Place}
            </Typography>
            <Typography textAlign={"center"} variant="h5">
              {companyInfo?.EMail}
            </Typography>
          </Stack>
        </Box>
      </Stack>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns?.map((data, idx) => {
                return (
                  <TableCell sx={headerStyle} key={idx}>
                    {data.headerName}
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {tabledata?.map((data, idx) => (
              <TableRow key={idx}>
                <TableCell sx={cellStyle}>{data?.BillDate}</TableCell>
                <TableCell sx={cellStyle}>{data?.RetNo}</TableCell>
                <TableCell sx={cellStyle}>{data?.BillPartyName}</TableCell>
                <TableCell sx={cellStyle}>{data?.salesType || "N/A"}</TableCell>
                <TableCell sx={cellStyle}>
                  {parseFloat(data?.BillNetTotalField || 0).toFixed(2)}
                </TableCell>
                <TableCell sx={cellStyle}>
                  {parseFloat(data?.BillDiscAmtField || 0).toFixed(2)}
                </TableCell>
                <TableCell sx={cellStyle}>
                  {parseFloat(data?.TaxAmt || data?.Tax || 0).toFixed(2)}
                </TableCell>
                <TableCell sx={cellStyle}>
                  {parseFloat(data?.BillTotalField || 0).toFixed(2)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableCell colSpan={4} sx={{ textAlign: "right" }}>
              {" "}
              <Typography fontWeight={600} variant="h5">
                Total
              </Typography>
            </TableCell>

            <TableCell sx={{ textAlign: "center" }}>
              <Typography fontWeight={600} variant="h5">
                {sumOfSubTotal?.toFixed(2)}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: "center" }}>
              <Typography fontWeight={600} variant="h5">
                {sumOfDisc?.toFixed(2)}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: "center" }}>
              <Typography fontWeight={600} variant="h5">
                {sumOfTax?.toFixed(2)}
              </Typography>
            </TableCell>
            <TableCell sx={{ textAlign: "center" }}>
              <Typography fontWeight={600} variant="h5">
                {sumOfTotalAmt?.toFixed(2)}
              </Typography>
            </TableCell>
          </TableFooter>
        </Table>
      </TableContainer>
    </div>
  );
}

export default SalesReturnReportPrint;
